import { Constants } from 'constants/constants'
import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'
import { TableData } from 'utils/data'

export const fetchTargetCircle360 = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/${Constants.GREENFIELD_CARDS.LOYALTY.TARGET_CIRCLE_360}`,
)
